import React from 'react'
import { Helmet } from 'react-helmet'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'

import EditView from 'bstrap-react-mobx-admin/view/edit'
import PropTypes from 'prop-types'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import RegionsInput from '../input/regions'

const RatingEditForm = ({ state }) => {
  const record = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(defaultConst.ENTNAMES.RATING, 'w')

  return (
    <div className='row'>
      <Helmet title={state.__(linkConst.LINK_RATING_TITLE).concat(defaultConst.HTML_DIVIDER) + (record.has('id')
        ? (record.has('name') ? record.get('name') : state.__(defaultConst.TITLE_EDIT))
        : state.__(defaultConst.TITLE_CREATE))} />
      <div className='col-sm-12 col-md-4 col-lg-4'>
        <TextInput
          label={state.__('name')}
          attr={'name'}
          record={record}
          onChange={updateField}
          errors={errors} disabled={disabled} />
        <TextInput
          label={state.__('description')}
          attr={'description'}
          record={record}
          onChange={updateField}
          errors={errors} disabled={disabled} />
        <TextInput type='number'
          label={state.__('minimum age')}
          attr={'minimum_age'}
          record={record}
          onChange={updateField}
          errors={errors} disabled={disabled} />
        <BoolInput label={state.__('parent guidance')} attr={'parent_guidance'}
          record={record} onChange={updateField} />
      </div>
      <div className='col-sm-12 col-md-8 col-lg-8'>
        <RegionsInput store={state} label={state.__('regions')} attr={'regions'}
          record={record} onChange={updateField} errors={errors}
          optionsrecord={state.options} optionsattr={'Countries'} /><br />
        <RegionsInput store={state} label={state.__('default regions')} attr={'regions_default'}
          record={record} onChange={updateField} errors={errors}
          optionsrecord={state.options} optionsattr={'Countries'} />
      </div>
    </div>
  )
}

RatingEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const RatingEditView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.RATING)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.RATING, 'w')} >
      <RatingEditForm state={store} />
    </EditView>
  )
}
export default RatingEditView
